<template>
    <div class="modal fade action-sheet" id="sender" :class="{'inset' : inset}" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Kirim OTP</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content" :class="{'p-0' : contentFull}">
                        <div class="text-center">
                            <h4>Pilih Metode Verifikasi</h4>
                            <small style="line-height:normal;">Pilih salah satu metode dibawah ini untuk mendapatkan kode OTP</small>
                        </div>
                        <div class="mt-3" v-if="!loading">
                            <button class="btn btn-text-primary shadowed btn-block btn-lg" v-for="item in sender" :key="item.id" @click="requestOTP(item.id)">{{ item.name }} ke {{ phone }}</button>
                        </div>
                        <div class="mt-3 text-center text-primary p-1" v-else>
                            <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span> Proses Mengirim...
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    props:{
        phone:{
            type: String,
            required : true,
        },
        inset:{
            type: Boolean,
            required : false,
            default: true
        },
        contentFull: {
            type: Boolean,
            required : false,
            default: false
        }
    },
    data(){
        return {
            loading: false
        }
    },
    computed:{
         ...mapState('sender',{
            sender: state => state.sender,
        }),
    },
    methods:{
        ...mapActions('sender', ['getSender','requestCode']),
        requestOTP(id){
            this.loading = true
            this.requestCode({sender_id:id,phone:this.phone}).then(() => {
                this.loading = false
                this.$store.commit('SET_TOAST', {show:true,message:'Kode OTP berhasil dikirim, silahkan periksa pesan masuk kamu',tipe:'default',icon:'success'})
                window.$('#sender').modal('hide')
            }).catch((error) => {
                this.loading = false
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'default',icon:'danger'})
                window.$('#sender').modal('hide')
            })
        }
    },
    mounted(){
        this.getSender()
    }
}
</script>